import { render } from "./SegregationPlan.vue?vue&type=template&id=393257d3&ts=true"
import script from "./SegregationPlan.vue?vue&type=script&lang=ts"
export * from "./SegregationPlan.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__